import React, {Component} from 'react';
import "./HomeContent.css";
import ImageSlider from "./ImageSlider/ImageSlider";
import PCBService from "./PCBService/PCBService";
import PCBVideo from "./PCBVideo/PCBVideo";
import VideoSlider from "./VideoSlider/VideoSlider";
import Footer from "./Footer/Footer";
import PrintBoardEstimate from "./PrintBoardEstimate/PrintBoardEstimate";
import InformationNotice from "./InformationNotice/InformationNotice";
import ServiceSectionBottom from "./ServiceSectionBottom/ServiceSectionBottom";
import KitCutLaboSection from "./KitCutLaboSection/KitCutLaboSection";
import ResponsiveHomeContent from "./ResponsiveHomeContent";
import MetaTags from 'react-meta-tags';

class HomeContent extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div className="kitcut-home-content">
                <MetaTags>
                    <title>１枚から量産価格｜プリント基板のネット通販｜KITCUT PCB </title>
                    <meta property="title" content="１枚から量産価格｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="１枚から量産価格｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="image-slider-div">
                    <ImageSlider/>
                </div>
                <span className="web-view">
                    <div className="pcb-service-div">
                    <KitCutLaboSection/>
                </div>
                <hr className="hr-bold home-pg-hr no-padding"/>
                <div className="pcb-service-bottom-div">
                    <ServiceSectionBottom/>
                </div>
                    <hr className="hr-bold home-pg-hr no-padding"/>
                    <div className="content-with-padding pcb-service-div2">
                    <PCBService/>
                    </div>
                    <hr className="hr-bold home-pg-hr no-padding"/>
                    <div className="content-with-padding pcb-video-div">
                    <PCBVideo/>
                    </div>
                    <hr className="hr-bold home-pg-hr no-padding"/>
                    <div className="video-slider-div">
                    <VideoSlider/>
                    </div>
                    <hr className="hr-bold home-pg-hr no-padding"/>
                    <div className="content-with-padding print-board-estimate-div">
                    <PrintBoardEstimate/>
                    </div>
                    <hr className="hr-bold home-pg-hr no-padding"/>
                    <div className="content-with-padding information-notice-div">
                    <InformationNotice/>
                    </div>
                    {/*<div className="site-footer-div">*/}
                    {/*<Footer/>*/}
                    {/*</div>*/}
                </span>
                <span className="mobile-view-home">
                   <ResponsiveHomeContent/>
                </span>
            </div>
        );
    }
}

export default HomeContent;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/HomeContent.js